module.exports = __webpack_public_path__ + "static/media/LightRain.e4e8fc1d.svg";